import { Layout as AntdLayout, type LayoutProps as AntdLayoutProps } from 'antd'

type FooterProps = AntdLayoutProps

export function Footer(props: FooterProps) {
  return <AntdLayout.Footer {...props} />
}
